import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@chakra-ui/react';
import ModalLayout from './modalLayout';
import { useTranslation } from 'react-i18next';

export const InfoModalMode = Object.freeze({
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
});

const InfoModal = ({ open, bodyText, bodyTextProps, mode, headerText, ...rest }) => {
  const { t } = useTranslation();

  let heading;
  if (mode === InfoModalMode.Info) {
    heading = t('modal.info');
  } else if (mode === InfoModalMode.Warning) {
    heading = t('modal.warning');
  } else {
    heading = t('modal.error');
  }

  return (
    <ModalLayout
      open={open}
      headerText={headerText || heading}
      rightButtonProps={{ color: 'white' }}
      footerProps={{ borderTop: 'none' }}
      rightButtonText={t('modal.ok')}
      {...rest}
    >
      <Text {...bodyTextProps}>
        {bodyText && bodyText.i18nKey ? t(bodyText.i18nKey) : bodyText}
      </Text>
    </ModalLayout>
  );
};

InfoModal.propTypes = {
  open: PropTypes.bool,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bodyTextProps: PropTypes.object,
  mode: PropTypes.string,
};

InfoModal.defaultProps = {
  open: false,
  headerText: '',
  bodyText: '',
  bodyTextProps: {},
  mode: InfoModalMode.Info,
};

export default InfoModal;
